/*
 * @Author: edvardchen
 * @Date:   2016-11-22 14:55:50
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2021-01-26 17:38:13
 */

// @flow
import cookies from 'js-cookie';
import { post } from './fetch';
// import C4PV from '../utility/C4PV';
// import Qua from '@tencent/parse-qua/parse_qua';
// import cookies from 'js-cookie';
// import _ from 'lodash';

// #if process.env.WEBPACK_ENV_TARGET === 'client'
import LoginSyncModule from '@tencent/qb-login-sync-module';
// #endif

type Data = {
  id: string,
  actType?: number,
  qbid?: string,
  ch?: string,
  ext?: Object,
};
type Circle = {
  inner?: string,
  circleId: string,
  ch?: string,
  action?: string,
};

export const subscribe = ({ id, actType = 9, ext = {} }: Data) => {
  return LoginSyncModule.follow(id, actType, ext.reportObj ? ext.reportObj : {});
};

export const kdFollowReq = (userList, businessInfo) => {
  return LoginSyncModule.qqkdFollow(userList, businessInfo);
};
/* post('/api/subscriptions/add', {
    body: { id, qbid, ch, inner }
  }); */
// post('/api/circles/followPerson', {
//   body: {
//     userId: id,
//     accountType: actType,
//     noNeedLogin: noNeedLogin ? '1' : '0',
//     qbid,
//     ext: JSON.stringify(ext),
//   },
// });

/**
 * 取消订阅
 * @return {Promise}
 */
export const unsubscribe = ({ id, actType = 9, ext = {} }: Data) => {
  return LoginSyncModule.unFollow(id, actType, ext.reportObj ? ext.reportObj : {});
};
// post('/api/circles/unFollowPerson', {
//   body: {
//     userId: id,
//     accountType: actType,
//     noNeedLogin: noNeedLogin ? '1' : '0',
//     qbid,
//     /* ext: JSON.stringify({
//       locationId: 2,
//       usinessType: 2,
//       ...ext,
//     })*/
//   },
// });

export const check = ({ id, qbid, ch }: { id: string | string[], qbid?: string, ch?: string }) =>
  post('/api/subscriptions/check', {
    body: { id, qbid, ch },
  });

/**
 * 关注后获取相关推荐
 * @return {Promise}
 */
export const fetchRecommandCircles = ({ id, qbid, ch }: Data) =>
  post('/api/subscriptions/recommandCircle', { body: { id, qbid, ch } });
/**
 * 关注后获取相关推荐账号曝光上报
 * @return {Promise}
 */
export const recommendAccountReport = (userID: string) =>
  post('/api/subscriptions/reAccLog', {
    body: { userID },
  });
export const fetchRecommendAccount = async ({ qbid, lastFollowUserId, lastFollowActType, docId, subjectId }: *) => {
  // return post('/api/subscriptions/recommendAccount', {
  //   body: { qbid, lastFollowUserId, lastFollowActType, docId, subjectId },
  // });
  const qua = cookies.get('qb_qua') || '';
  const guid = cookies.get('qb_guid') || '';

  const reqObj = {
    qua,
    guid,
    count: 12,
    scene: 'article_detail',
    lastestFollowed: {
      eAccountType: Number(lastFollowActType),
      sUserId: lastFollowUserId,
    },
    docID: docId,
    subjectID: subjectId,
  };
  reqObj.user = {
    eAccountType: 5,
    sUserId: qbid || '',
  };
  return post('https://usercenter.html5.qq.com/accrecomm/', {
    conType: 'application/json',
    body: JSON.stringify(reqObj),
  });
};
/**
 * 圈子曝光上报
 *@returns {Promise}
 */
export const reportCirclePV = (circles: Array<Circle>) => {
  post('/api/subscriptions/circlePV', {
    body: { pvInfo: JSON.stringify(circles) },
  });
};
/**
 * 福利中心检查用户状态
 */
export const checkWelfareInfo = (userInfo: Object) =>
  post('/api/welfare/checkUser', {
    body: userInfo,
  });

/**
 * 福利中心更新用户状态
 */
export const updateWelfareInfo = (userInfo: Object) =>
  post('api/welfare/finishTask', {
    body: userInfo,
  });

/**
 * 记录读书记录
 */
export const welfareReadInfo = (userInfo: Object, readInfo: Object) => {
  const info = { ...userInfo, ...readInfo };
  return post('api/welfare/readInfo', {
    body: info,
  });
};
